import { TFunction } from 'i18next';

export const schema = (t: TFunction) => ({
  title: t('subscriber:membershipChange.title', 'Change your membership'),
  name: 'header',
  description: t(
    'subscriber:membershipChange.description',
    'Select your preferred application and/or assessment types.'
  ),
  pages: [
    {
      stepName: 'SubscriptionUpdateRequest',
      showCompleteButton: false,
      elements: [
        {
          type: 'mui-select',
          name: 'applicationType',
          titleLocation: 'hidden',
          title: t('subscriber:survey.chooseApplicationType', 'Health and Safety application type'),
          choices: [
            {
              value: 'Contractor - Construction',
              text: t('subscriber:survey.applicationType.construction', 'Construction'),
              tooltip: t(
                'subscriber:survey.applicationType.constructionDetails',
                'Any work carried out in connection with the construction, alteration, conversion,  fitting-out, commissioning, renovation, repair, maintenance, refurbishment, demolition, decommissioning or dismantling of a structure, or preparation of a building site.'
              )
            },
            {
              value: 'Principal Contractor',
              text: t('subscriber:survey.applicationType.principalContractor', 'Principal contractor'),
              tooltip: t(
                'subscriber:survey.applicationType.principalContractorDetails',
                'The contractor with control over the construction phase of a project to plan, manage,  monitor and coordinate health and safety involving more than one contractor.'
              )
            },
            {
              value: 'Designer',
              text: t('subscriber:survey.applicationType.designer', 'Designer'),
              tooltip: t(
                'subscriber:survey.applicationType.designerDetails',
                'Individuals or organisations such as architects, consulting engineers or quantity surveyors. This includes anyone who specifies and alters designs as part of their work.'
              )
            },
            {
              value: 'Principal Designer',
              text: t('subscriber:survey.applicationType.principalDesigner', 'Principal designer'),
              tooltip: t(
                'subscriber:survey.applicationType.principalDesignerDetails',
                'An organisation or individual who takes the lead in planning, managing, monitoring and coordinating health and safety during the pre-construction phase of a project.'
              )
            },
            {
              value: 'Care',
              text: t('subscriber:survey.applicationType.care', 'Care'),
              visibleIf: '{info.currentSubscription} != "CHAS Elite"',
              tooltip: t(
                'subscriber:survey.applicationType.careDetails',
                'An organisation that provides services such as residential nursing homes, domiciliary/day care, or other support services in the care sector.'
              )
            },
            {
              value: 'SSIP Approved (Non-Construction)',
              text: t('subscriber:survey.applicationType.ssipApproved', 'SSIP approved (non-construction)'),
              tooltip: t(
                'subscriber:survey.applicationType.ssipApprovedDetails',
                'Not working in connection with any construction activities. e.g. Transportation or Catering Services.'
              )
            }
          ]
        },
        {
          type: 'mui-select',
          name: 'assessmentType',
          isRequired: true,
          titleLocation: 'hidden',
          title: t('subscriber:survey.chooseAssessmentType', 'Health and Safety assessment type'),
          choices: [
            {
              value: 'Direct Application',
              text: t('subscriber:survey.assessmentType.fullApplication', 'Full application'),
              tooltip: t(
                'subscriber:survey.assessmentType.fullApplicationDetails',
                'A full assessment of your Health & Safety Management System, hosted online and reviewed via a qualified CHAS assessor.'
              )
            },
            {
              value: 'DTS',
              text: t('subscriber:survey.assessmentType.deemToSatisfy', 'Deem to satisfy'),
              visibleIf: '{info.currentSubscription} != "CHAS Elite"',
              tooltip: t(
                'subscriber:survey.assessmentType.deemToSatisfyDetails',
                'You can ONLY obtain a Deemed to Satisfy (DTS) Certificate if you have a valid assessment with another SSIP scheme operator. Please ensure you have completed the SSIP element with your certification body, so that your certificate details are populated on the SSIP portal. If you do not hold a valid assessment with another SSIP operator, you must apply for a CHAS Assessment.'
              )
            },
            {
              value: 'Assured',
              text: t('subscriber:survey.assessmentType.assuredOnSiteAudit', 'Assured (on-site audit)'),
              visibleIf: '{applicationType} != "Care"',
              tooltip: t(
                'subscriber:survey.assessmentType.assuredOnSiteAuditDetails',
                'A full assessment of your Health  & Safety Management System, in the form of an in-person visit from a qualified CHAS assessor.'
              )
            }
          ],
          requiredErrorText: t('subscriber:survey.validation.makeSelection', 'Please make a selection')
        },
        {
          type: 'mui-complete-button',
          titleLocation: 'hidden'
        }
      ]
    }
  ],
  clearInvisibleValues: 'onHiddenContainer',
  showCompletedPage: false,
  completeText: t('subscriber:survey.navigation.requestChange', 'Request change'),
  showNavigationButtons: false
});
